<template>
  <div class="project-outbox">
    <div class="project">
      <div class="title">告警管理</div>
      <div class="pro-info">
        <div class="left">
          <el-select v-model="optionValue" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="right">
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="input2"
          >
          </el-input>
          <el-button type="primary" class="search">搜索</el-button>
        </div>
      </div>
      <div class="table-box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="number" label="编号"> </el-table-column>
          <el-table-column prop="name" label="告警名称"> </el-table-column>
          <el-table-column prop="device" label="监控设备"> </el-table-column>
          <el-table-column prop="describe" label="告警描述" width="260">
          </el-table-column>
          <el-table-column prop="type" label="类型"> </el-table-column>
          <el-table-column prop="mode" label="推送方式"> </el-table-column>
          <el-table-column prop="user" label="推送角色"> </el-table-column>
          <el-table-column prop="edit" label="操作" width="200">
            <template slot-scope="scope">
              <div class="btn-out-box">
                <div
                  class="btn-box color1"
                  title="编辑"
                  @click="setUser(scope.row)"
                >
                  <i class="iconfont icon-bianji1"></i>
                </div>
                <div
                  class="btn-box color2"
                  title="删除"
                  @click="deleteUser(scope.row)"
                >
                  <i class="iconfont icon-close"></i>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination
        background
        layout="prev, pager, next"
        :total="100"
        @current-change="paginationHandle"
      >
      </el-pagination> -->
      <el-dialog title="新增项目" :visible.sync="dialogFormVisible">
        <el-form :label-position="'right'" label-width="120px" :model="form">
          <el-form-item label="项目ID">
            <el-input v-model.trim="form.projectId"></el-input>
          </el-form-item>
          <el-form-item label="服务起止日期：">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="form.date1"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">~</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="form.date2"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="项目名称：">
            <el-input v-model.trim="form.projectName"></el-input>
          </el-form-item>
          <el-form-item label="装机容量：">
            <el-input v-model.trim="form.capacity"></el-input>
          </el-form-item>
          <el-form-item label="负责人：">
            <el-input v-model.trim="form.person"></el-input>
          </el-form-item>
          <el-form-item label="申报数量：">
            <el-input v-model.trim="form.count"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：">
            <el-input v-model.trim="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="电压等级：">
            <el-input v-model.trim="form.level"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: false,
      input2: "",
      tableData: [
        {
          number: "1",
          name: "开关量报警",
          device: "仪表",
          describe: "开关量报警，请及时检查",
          type: "1",
          mode: "2016-05-02",
          user: "3",
          isOpen: false,
        },
        {
          number: "2",
          name: "电流过载报警",
          device: "仪表",
          describe: "电流过载报警，值为X，请及时检查",
          type: "2",
          mode: "2016-05-02",
          user: "3",
          isOpen: true,
        },
      ],
      dialogFormVisible: false,
      form: {
        projectId: "",
        projectName: "",
        date1: "",
        date2: "",
        capacity: "",
        person: "",
        count: "",
        phone: "",
        level: "",
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      optionValue: "",
    };
  },
  methods: {
    changeSwitch(scope) {
      console.log(scope);
    },
    downloadHandle(scope) {
      console.log(scope);
    },
    editselfHandle(scope) {
      console.log(scope);
      if (!scope.row.isOpen) return;
      let id = scope.row.projectId;
      this.$router.push({
        path: `/info/${id}`,
      });
    },
    paginationHandle(index) {
      console.log(index);
    },
  },
};
</script>
<style lang="less" scoped>
.project-outbox {
  padding: 20px;
}
.project {
  background: #f8f8f9;
  border-radius: 7px;
  padding: 24px;
  .title {
    font-size: 18px;
    color: #0e223d;
    letter-spacing: 2px;
    font-weight: 600;
    text-align: left;
  }
  .pro-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 28px;
    .left {
      font-size: 16px;
      color: #0e223d;
      span {
        &:last-of-type {
          font-weight: 600;
        }
      }
    }
    .right {
      display: flex;
      .el-input {
        margin-right: 10px;
      }
      .search {
        margin-right: 20px;
      }
    }
  }
  .table-box {
    /deep/.el-table {
      background: rgba(0, 0, 0, 0);
      th,
      tr {
        background: rgba(0, 0, 0, 0);
      }
      th {
        > .cell {
          color: #152139;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }
      tr {
        td {
          text-align: center;
          font-size: 14px;
          color: #152139;
        }
      }
      .btn-out-box {
        display: flex;
        justify-content: space-around;
      }
      .btn-box {
        width: 24px;
        height: 24px;
        background: rgba(165, 165, 165, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .iconfont {
          font-size: 12px;
          color: rgba(195, 195, 195, 1);
        }
        &.color1:hover {
          background: rgba(20, 96, 224, 0.1);
          .iconfont {
            color: rgba(20, 96, 224, 1);
          }
        }
        &.color2:hover {
          background: rgba(255, 41, 41, 0.1);
          .iconfont {
            color: rgba(255, 41, 41, 1);
          }
        }
      }
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 30px;
  }
  .el-dialog {
    width: 35%;
    .el-dialog__title {
      font-weight: 600;
    }
    .el-input {
      // width: 323px;
    }
    .line {
      text-align: center;
    }
  }
}
</style>
